import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import AdminLayout from './layouts/AdminLayout';

import RecibosPage from './pages/RecibosPage';
import HistoricoPage from './pages/HistoricoPage';
import DetalleReciboPage from './pages/DetalleReciboPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import EmpresasPage from './pages/EmpresasPage';
import PersonasPage from './pages/PersonasPage';
import CatalogosPage from './pages/CatalogosPage';
import DashboardPage from './pages/DashboardPage';
import { obtenerTokenSesion } from './utils/sesion';

function RutaProtegida() {
  const token = obtenerTokenSesion();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <AdminLayout />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route
          path="/login"
          element={<LoginPage />}
        />

        <Route
          path="/"
          element={<RutaProtegida />}
        >
          <Route
            index
            element={<DashboardPage />}
          />

          <Route
            path="dashboard"
            element={<DashboardPage />}
          />

          <Route
            path="recibos"
            element={<RecibosPage />}
          />

          <Route
            path="historico"
            element={<HistoricoPage />}
          />

          <Route
            path="recibos/:id"
            element={<DetalleReciboPage />}
          />

          <Route
            path="configuracion"
            element={<ConfiguracionPage />}
          />

          <Route
            path="empresas"
            element={<EmpresasPage />}
          />

          <Route
            path="personas"
            element={<PersonasPage />}
          />

          <Route
            path="catalogos"
            element={<CatalogosPage />}
          />
        </Route>

        <Route
          path="*"
          element={
            <Navigate
              to={obtenerTokenSesion() ? '/dashboard' : '/login'}
              replace
            />
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
